// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__GFZ8f","item":"styles_item__bfF24","reflection":"styles_reflection__pj51A","background":"styles_background__1Aius"};